export default "__VITE_ASSET__DlZYXPqR__"